export default "__VITE_ASSET__cn7IAAGY294pWGc7MpElVg__"